import React from 'react';

function Input(props) {

    function onChange(event) {
        let { value } = event.target;
        props.onChange(value);   
    }

    return (
        <input
            value={props.value}
            onChange={onChange}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
            type={props.type}
            id={props.id}
            onFocus={props.onFocus}
        />
    );
}

export default Input;